export default __webpack_public_path__ + "static/media/clipbait_logo.7910811e.svg";